import {ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild, inject} from '@angular/core';
import {Router} from '@angular/router';
import {I18nService} from '../../../_services/gui/i18n.service';
import {TabBarService} from '../../../_services/gui/tab-bar.service';
import {IfsRequest} from '../../../_data/reports/ifs/ifs-request';
import {ConsumerReport} from '../../../_data/reports/consumer/consumer-report';
import {currentTimeFormatted, reformatDate} from '../../../_utils/lang';
import {ConsumerRequest} from '../../../_data/reports/consumer/consumer-request';
import {IFS_REQUEST_CACHE_KEY, IFS_RESPONSE_CACHE_KEY} from '../../../_constants/constants';
import {fromSessionOr} from '../../../_utils/storage';
import {CONSUMER_PDF_CSS} from '../../../_constants/pdf-report/consumer-css';
import {isConsumerRequestReport, isIfsRequest} from '../../../_utils/type-guards';
import {tap} from 'rxjs/operators';
import {IfsReport} from '../../../_data/reports/ifs/ifs-report';
import {IfsReportsService} from '../../../_services/data/reports/ifs-reports.service';
import {PdfReactorHeaderComponent} from '../../../common/pdf-reactor-header/pdf-reactor-header.component';
import {mergeSubjectIdentifiers} from 'src/app/_utils/consumer';
import {SidenavComponent} from '../../../sidenav/sidenav.component';
import {CardComponent} from '../../../sidenav/card/card.component';
import {PdfButtonBarComponent} from '../../../common/pdf-button-bar/pdf-button-bar.component';
import {IfsReportContentComponent} from './ifs-report-content/ifs-report-content.component';
import {TranslateModule} from '@ngx-translate/core';

export interface ConsumerRequestReport {
  req: ConsumerRequest;
  report: ConsumerReport;
}

@Component({
    selector: 'app-ifs-report',
    templateUrl: './ifs-report.component.html',
    styleUrls: ['./ifs-report.component.scss'],
    imports: [SidenavComponent, PdfReactorHeaderComponent, CardComponent, PdfButtonBarComponent, IfsReportContentComponent, TranslateModule]
})
export class IfsReportComponent implements OnInit, OnDestroy {

  reformatDate = reformatDate;
  mergeSubjectIdentifiers = mergeSubjectIdentifiers;
  isConsumerRequestReport = isConsumerRequestReport;

  _appCard: ElementRef;
  _creditReport: ElementRef;
  ifsReportCss = CONSUMER_PDF_CSS;

  ifsReport: IfsReport;
  _thisOrder: {lang?; ref?; branch?; resultsIssued?} = {};

  readonly inputData: IfsRequest | ConsumerRequestReport;

  i18nService = inject(I18nService);  
  private router = inject(Router);
  private ifsReportsService = inject(IfsReportsService);
  private tabBarService = inject(TabBarService);
  private cdRef = inject(ChangeDetectorRef);

  constructor() {
    const router = this.router;

    this.inputData = JSON.parse(sessionStorage.getItem(IFS_REQUEST_CACHE_KEY));
    if(!this.inputData) {
      console.warn('IFS request data missing');
      router.navigateByUrl('/consumer-services');
    }
    if(isIfsRequest(this.inputData)) {
      fromSessionOr(IFS_RESPONSE_CACHE_KEY, this.ifsReportsService.getReport(this.inputData)).pipe(
        tap(ifsData => console.debug('IFS Data', ifsData))
      ).subscribe(report => {
        console.info(`Report received - ${!!report?.body ? 'with content' : 'null'}`);
        this.ifsReport = report?.body;
      });
    }
  }

  ngOnInit() {
    this.i18nService.setTitle('title.results');
    this.tabBarService.show();
    this._thisOrder.resultsIssued = currentTimeFormatted();
  }

  ngOnDestroy() {
    //If the user intentionally navigates away from the report, clear the storage for the request/response.
    sessionStorage.removeItem(IFS_REQUEST_CACHE_KEY);
    sessionStorage.removeItem(IFS_RESPONSE_CACHE_KEY);
  }

  set thisOrder(value: {lang?; ref?; branch?; resultsIssued?}) {
    Object.assign(this._thisOrder, value);
    this.cdRef.detectChanges();
  }

  set creditReport(value: ElementRef) {
    this._creditReport = value;
    this.cdRef.detectChanges();
  }

  @ViewChild(PdfReactorHeaderComponent, {read: ElementRef})
  set appCard(appCard: ElementRef) {
    this._appCard = appCard;
    this.cdRef.detectChanges();
  }

}
